export default __webpack_public_path__ + "static/media/bundle-guide-us-white@2x.52e8bb32.jpg";